import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../App.css'
import Header from '../components/Header'
import DeviceContent from '../components/DeviceContent'
import { Logger } from "react-remote-logger"

class Device extends Component {
  componentDidMount() {
    Logger({
      'timestamp': (new Date()).toLocaleString(),
      'level': 'info',
      'user_id': localStorage.user_id,
      'user': localStorage.user_email,
      'organization': localStorage.organization,
      'action': 'GET',
      'url': window.location.href,
      'message': `GET ${window.location.href}`
    })
  }

  render () {
    return (
      <div className='App'>
        <Header
          enabled='device'
          org={this.props.match.params.org}
        />
        <DeviceContent
          org={this.props.match.params.org}
        />
      </div>
    )
  }
}

Device.propTypes = {
  match: PropTypes.object
}

export default Device
